import type { CallState } from './index.types';
import type { ConferenceState } from '../conferenceSlice/index.types';

/**
 * Returns true when there is an active conference session.
 * Uses the formal `activeConference` state instead of the previous heuristic
 * (>1 non-held active calls).
 */
export const isConferenceCallSelector = (state: CallState & ConferenceState): boolean =>
  state.activeConference !== null;
